"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.preview.title': 'Preview Tutorial',
    'tutorial.preview.introduction': 'Introduction',
    'tutorial.preview.learningSteps': 'Learning Steps',
    'tutorial.preview.tutorialSections': 'Tutorial Sections',
    'tutorial.preview.knowledgeEntries': 'knowledge entries',
    'tutorial.preview.sectionPrompt': 'Section Prompt',
    'tutorial.preview.knowledgeBase': 'Knowledge Base',
    'tutorial.preview.stepSections': 'Step Sections',
    'tutorial.preview.notFound': 'Tutorial Not Found',
    'tutorial.preview.notFoundMessage': 'The requested tutorial could not be found or you do not have permission to view it.',
};
